import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AddMainRoutesComponent } from './add-main-routes/add-main-routes.component';

const routes: Routes = [
  {
    path:'add-menu',component:AddMainRoutesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NavRoutesRoutingModule { }
